module.exports = __webpack_public_path__ + "img/stats.e9dd1e01.png";